module.exports = "<template>\r\n    <a href=\"#\" title.bind=\"title\" click.trigger=\"save()\">\r\n        <img src.bind=\"src\"/>\r\n    </a>\r\n</template>";